<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/FxI9N9/tc-custom/9781467727471.jpg?1718162162997" alt="This image is the cover for the book Mallory and Mary Ann Take New York, Mallory"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mallory and Mary Ann Take New York, Mallory
      </h1>
      <p class="bookDescription body article font2">
        <p>START SPREADING THE NEWS . . . Mallory and Mary Ann are headed to New York. They've got sights to see! The Empire State Building. The Statue of Liberty. Times Square. Central Park. But they also have a problem to solve. Only one of them is invited to appear on their favorite TV show, <i>Fashion Fran</i>. How can two best friends find a way to share a spotlight with room for only one?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Laurie Friedman, Jennifer Kalis
      </h2>
      
      <p class="authorDescription body article"><B>Jennifer Kalis</B> is the illustrator of several <B>Mallory</B> books including <I>Mallory's Super Sleepover</I>,&#160;<I>Mallory in the Spotlight</I>,&#160;and <I>Mallory Goes Green</I>! She lives in Ohio.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Lerner Publishing Group
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?bdb2793c